export default __webpack_public_path__ + "static/media/linesRight.bb664a5c.png";